import { postConsumption } from 'core/crud/contents.crud';
import { putJob } from 'core/crud/jobs.crud';
import useAmplitude from 'core/hooks/useAmplitude';
import { successResponse } from 'core/utils/utils';

function useMaterialPreviewLink({ material, course }) {
  const { sendAmplitudeEvent, AMPLITUDE_EVENT } = useAmplitude();

  async function initConsumption(contentGuid) {
    const consumptions = await postConsumption({ content_guid: contentGuid, progress_ends: 1, type: 'link' });
    if (successResponse(consumptions)) {
      const newConsumption = consumptions.data.data;
      updateJobStatusProgress(newConsumption, material.job?.id);
    }
  }

  async function updateJobStatusProgress(data, jobGuid) {
    if (data && jobGuid) {
      putJob(jobGuid, {
        progress: 1,
        status: 'delivered',
      });
    }
  }
  function onOpenLink() {
    if (material.content_guid && material.job?.id) {
      initConsumption(material.content_guid);
    }
    window.open(material.content_url, '_blank');

    const extraParams = { content_type: material.type, content_guid: material.content_guid, from: 'lesson' };
    sendAmplitudeEvent(AMPLITUDE_EVENT.OPEN_CONTENT, extraParams, course);
  }
  return { onOpenLink };
}

export default useMaterialPreviewLink;
